// src/pages/Shop.jsx
import React, { useEffect, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import ShopPage from "../components/ShopPage.jsx";
import SEO from "../components/SEO.jsx";

// Keep titles consistent with your handle→filter mapping
const COLLECTION_LABELS = {
  all: "Shop All",
  bralettes: "Bralettes",
  knickers: "Knickers",
  swimwear: "Swimwear",
  "double-denim-silk-pyjamas": "Clothing",
  accessories: "Accessories",
  personalised: "Personalised",
};

function Shop() {
  const { collectionHandle } = useParams(); // /collections/:collectionHandle
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Always canonicalise to the clean collection URL (ignore ?filter= etc)
  const canonicalPath = useMemo(() => {
    const handle = collectionHandle || "all";
    return `/collections/${handle}`;
  }, [collectionHandle]);

  const title = useMemo(() => {
    const handle = collectionHandle || "all";
    const label = COLLECTION_LABELS[handle] || handle;
    return handle === "all" ? "Shop All" : `Shop ${label}`;
  }, [collectionHandle]);

  const description = useMemo(() => {
    const handle = collectionHandle || "all";
    const label = COLLECTION_LABELS[handle] || handle;
    return handle === "all"
      ? "Shop all This Belongs To pieces — underwear, swimwear, clothing and accessories."
      : `Shop ${label} from This Belongs To — independent underwear and clothing.`;
  }, [collectionHandle]);

  return (
    <Layout>
      <SEO title={title} description={description} path={canonicalPath} />
      <ShopPage key={location.pathname} />
    </Layout>
  );
}

export default Shop;
